<template>
  <div class="main-page" ref="techPage">
    <div class="first-page">
      <div class="font-area" :class="globalTransition">
        <div class="explain">
          <p>{{$t('techPage.p1.title')}}</p></div>
        <div class="p1">
          <p>{{$t('techPage.p1.p1')}}</p>
         </div>
        <div class="p2">
          <p>{{$t('techPage.p1.p2')}}<br>
        {{$t('techPage.p1.p3')}}<br>
        {{$t('techPage.p1.p4')}}</p></div>
        <div class="p3">
          <p>{{$t('techPage.p1.p5')}}<br>
         {{$t('techPage.p1.p6')}}</p></div>
      </div>
      <transition name="fade">
        <div v-if="!hideDownBtn"
             class="p5" @mouseenter="rightArrowShow=true"
             @mouseleave="rightArrowShow=false"
             @click="jump2nextPage('TEDetail')"
        >
          <transition name="fade">
            <div class="icon-div" :class="rightArrowShow?'show':''">
              <i class="el-icon-arrow-down"></i></div>
          </transition>
        </div></transition>
    </div>
    <div class="te-detail blue color-block" ref="TEDetail">
      <div class="left">
        <div class="img-area">
          <img :src="t$eImg1Url" alt="DIMER">
        </div>
      </div>
      <div class="right">
        <div class="detail-font-area" :class="globalTransition">
          <div class="title">{{$t('techPage.p2.title')}}</div>
          <div class="content padding-top">{{$t('techPage.p2.p1')}}</div>
          <div class="content padding-top">{{$t('techPage.p2.p2')}}</div>
          <div class="content">{{$t('techPage.p2.p3')}}</div>
          <div class="content">{{$t('techPage.p2.p4')}}</div>
        </div>
      </div>
    </div>

    <div class="te-detail" ref="gasProcessTech">
      <div class="right">
        <div class="detail-font-area" :class="globalTransition">
          <div class="title">{{$t('techPage.p3.title')}}</div>
          <div class="content padding-top">{{$t('techPage.p3.p1')}}</div>
          <div class="content padding-top">{{$t('techPage.p3.p2')}}</div>
          <div class="content">{{$t('techPage.p3.p3')}}</div>
          <div class="content">{{$t('techPage.p3.p4')}}</div>
          <div class="content">{{$t('techPage.p3.p5')}}</div>
        </div>
      </div>
      <div class="left">
        <div class="img-area">
          <img :src="t$eImg1Url2" alt="DIMER">
        </div>
      </div>
    </div>

    <div class="te-detail color-block2" ref="ptgTech">
    <div class="left">
      <div class="img-area">
        <img :src="t$eImg1Url3" alt="DIMER">
      </div>
    </div>
    <div class="right">
      <div class="detail-font-area" :class="globalTransition">
        <div class="title">{{$t('techPage.p4.title')}}</div>
        <div class="content padding-top">{{$t('techPage.p4.p1')}}</div>
        <div class="content padding-top" style="white-space: nowrap">{{$t('techPage.p4.p2')}}</div>
        <div class="content">
          {{$t('techPage.p4.p3')}}</div>
        <div class="content">{{$t('techPage.p4.p4')}}</div>
        <div class="content">{{$t('techPage.p4.p5')}}</div>
        <div class="content">{{$t('techPage.p4.p6')}}</div>
        <div class="content">{{$t('techPage.p4.p7')}}</div>
      </div>
    </div>
  </div>

    <div class="te-detail color-block3" ref="cleanEnergyDev">
      <div class="right">
        <div class="detail-font-area" :class="globalTransition">
          <div class="title">{{$t('techPage.p5.title')}}</div>
          <div class="content padding-top">{{$t('techPage.p5.p1')}}</div>
          <div class="content padding-top">{{$t('techPage.p5.p2')}}</div>
          <div class="content"  :class="language==='zh'?'padding-top':''">
            {{$t('techPage.p5.p3')}}</div>
          <div class="content">{{$t('techPage.p5.p4')}}</div>
        </div>
      </div>
      <div class="left">
        <div class="img-area">
          <img :src="t$eImg1Url4" alt="DIMER">
        </div>
      </div>
    </div>
    <div class="divider-div"> <el-divider class="divider"></el-divider></div>
    <relevant></relevant>
    <footMenu></footMenu>
  </div>
</template>

<script>
import relevant from '@/views/techPage/relevant';
import footMenu from '@/components/footMenu';
import t$eImg1 from '@/assets/t$eImg1.jpg';
import t$eImg2 from '@/assets/t$eImg2.jpg';
import t$eImg3 from '@/assets/t$eImg3.jpg';
import t$eImg4 from '@/assets/t$eImg4.jpg';

export default {
  name: 'projectPage',
  components: {
    relevant,
    footMenu,
  },
  data() {
    return {
      rightArrowShow: false,
      doTransition: true,
      showDiscoveryPage: false,
      hideDownBtn: false,
      t$eImg1Url: t$eImg1,
      t$eImg1Url2: t$eImg2,
      t$eImg1Url3: t$eImg3,
      t$eImg1Url4: t$eImg4,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, true);
    this.author = this.$route.query.anchor;
    this.jump2nextPage(this.author);
  },
  computed: {
    language() {
      return this.$store.getters.language;
    },
    globalTransition() {
      return this.$store.getters.globalTransition ? 'global-i18n-hide' : 'global-i18n-not-hide';
    },
    anchor() {
      return this.$route.query.anchor;
    },
  },
  watch: {
    globalTransition() {
      this.doTransition = !this.doTransition;
    },
    anchor() {
      this.jump2nextPage(this.anchor);
    },
  },
  methods: {
    showDiscoveryBtnClick() {
      this.showDiscoveryPage = true;
      this.rightArrowShow = false;
    },
    handleScroll() {
      // eslint-disable-next-line
        if (this.$refs.techPage.scrollTop!==0) {
        this.hideDownBtn = this.$refs.techPage.scrollTop >= 40;
      }
    },
    jump2nextPage(ref) {
      const that = this;
      let distance = this.$refs.techPage.scrollTop;
      const total = this.$refs[ref].offsetTop - 100;
      let step = total / 50;
      if (total > distance) {
        // eslint-disable-next-line
          scrollDown();
      } else {
        const newTotal = distance - total;
        step = newTotal / 50;
        // eslint-disable-next-line
          scrollUp();
      }


      function scrollDown() {
        if (distance < total) {
          distance += step;
          that.$refs.techPage.scrollTop = distance;
          window.pageYOffset = total;
          setTimeout(scrollDown, 8);
        } else {
          that.$refs.techPage.scrollTop = total;
          window.pageYOffset = total;
        }
      }
      function scrollUp() {
        if (distance > total) {
          distance -= step;
          that.$refs.techPage.scrollTop = distance;
          window.pageYOffset = total;
          setTimeout(scrollUp, 10);
        } else {
          that.$refs.techPage.scrollTop = total;
          window.pageYOffset = total;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .main-page{
    background-image:url("../../assets/t$ePageBG1.jpg");
    background-repeat:no-repeat;
    background-size:100% 100%;
    height: 100%;
    width: 100%;
    overflow-x: hidden;
  }
  .first-page{
    width: 100%;
    height: 100%;
    padding-top: 10vh;
  }
  .font-area{
    color: #fff;
  }
  .discovery-page{
    height: 100%;
    width: 100%;
  }
  .te-detail{
    width: 100%;
    padding:7.5rem 6.7% 0 6.7%;
    background-color: #fff;
    color: #000;
    display: flex;
    .img-area{
     width: 50vw;
      img{
        width: 100%;
      }
    }
    .detail-font-area{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: start;
      height: 100%;
      padding: 0 14%;
      text-align: left;
      .title{
        font-size: 3rem;
        font-weight: bold;
        word-break: break-word;
      }
      .content{
        font-size: 1.1rem;
        line-height: 2rem;
      }
      .padding-top{
        padding-top: 3rem;
      }
    }
  }
  .blue{
    color:#369ff6
  }
p{
  margin-block-start: 0.3em!important;
  margin-block-end: 0.3em!important;
}
  .divider-div {
    width: 100%;
    background-color: #fff;
    display: flex;
    justify-content: center;
    height: 240px;
    padding-top: 120px;
    .divider{
      width: 86.6%;
      margin: 0!important;
      background-color: #ccc;
      height: 1px!important;
    }
  }
  .color-block{
    background-size: 14vw;
    background-position: 48vw 96%;
    padding-bottom: 7.5rem;
    background-repeat: no-repeat;
    background-image:url("../../assets/color-block.png");
  }
  .color-block2{
    background-size: 30vw;
    background-repeat: no-repeat;
    background-image:url("../../assets/color-block.png");
  }
  .color-block3{
    padding-bottom: 6.7rem;
    background-image:url("../../assets/color-block.png"),url("../../assets/color-block.png");
    background-size: 30vw,7vw;
    background-position: 100% 100%,0% 100%;
    background-repeat: no-repeat,no-repeat;
    }
</style>
<style>
  .el-carousel__indicators--outside{
    display: none!important;
  }
  .el-carousel__arrow{
    background: transparent!important;
    color: #369ff6!important;
    border: #369ff6 solid 1px!important;
  }
</style>



// WEBPACK FOOTER //
// src/views/techPage/index.vue